import { z } from "zod";

/**
 * Zod 4 probes `new Function("")` the first time it parses an object, to decide whether it may
 * compile fast parsers. Our CSP forbids eval, so that probe logs a CSP violation on every page.
 * Jitless mode skips the probe (and eval). Imported first in main.tsx, before anything parses.
 */
z.config({ jitless: true });
